export interface GeoIPInfo {
  region: string;
  city: string;
  cityLatLong: string;
  country: string;
  regionCode: string;
  postalCode: string;
  timezone: string;
  isEUCountry: boolean | string;
}

export const getGeoInfoByIP = (): Promise<GeoIPInfo> => {
  return fetch('https://location.linktivity.io/').then(res => res.json());
};
